(() => {
  const hero = document.querySelector('[data-hero-root]');
  const dialog = document.querySelector('[data-builder-dialog]');
  const form = document.querySelector('#FjordhavenUploadForm');
  const sticky = document.querySelector('[data-sticky-cta]');
  const openers = Array.from(document.querySelectorAll('[data-open-builder]'));
  const sessionId = window.crypto?.randomUUID?.() || `fh-${Date.now()}`;

  const track = (event, extra = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, session_uuid: sessionId, ...extra });
  };

  if (!dialog || !form) return;

  const closeButton = dialog.querySelector('[data-close-builder]');
  const builderStep = dialog.querySelector('[data-builder-step]');
  const builderTitle = dialog.querySelector('[data-builder-title]');
  const builderIntro = dialog.querySelector('[data-builder-intro]');
  const uploadStep = form.querySelector('[data-upload-step]');
  const detailsStep = form.querySelector('[data-details-step]');
  const renderingStep = form.querySelector('[data-rendering-step]');
  const previewStep = form.querySelector('[data-preview-step]');
  const input = form.querySelector('[data-photo-input]');
  const photoPreview = form.querySelector('[data-photo-preview]');
  const renderingPhoto = form.querySelector('[data-render-photo]');
  const coverPhoto = form.querySelector('[data-preview-cover-photo]');
  const dedicationPhoto = form.querySelector('[data-preview-dedication-photo]');
  const fileName = form.querySelector('[data-photo-name]');
  const reset = form.querySelector('[data-photo-reset]');
  const fileError = form.querySelector('[data-file-error]');
  const nameField = form.querySelector('[name="properties[Child name]"]');
  const eyesField = form.querySelector('[name="properties[Eye color]"]');
  const hairField = form.querySelector('[name="properties[Hair]"]');
  const previewViewed = form.querySelector('[data-preview-viewed-property]');
  const generateButton = form.querySelector('[data-generate-preview]');
  const orderButton = form.querySelector('[data-order-book]');
  const orderError = form.querySelector('[data-order-error]');
  const editDetails = form.querySelector('[data-edit-details]');
  const renderStages = Array.from(form.querySelectorAll('[data-render-stage]'));
  const previewTabs = Array.from(form.querySelectorAll('[data-preview-tab]'));
  const previewPanels = Array.from(form.querySelectorAll('[data-preview-panel]'));
  const maxBytes = 10 * 1024 * 1024;
  const allowedTypes = new Set(['image/jpeg', 'image/png']);
  let objectUrl = '';
  let state = 'upload';
  let hasPreview = false;
  let renderRun = 0;

  const copyByState = {
    upload: {
      step: 'Step 1 of 3',
      title: 'Choose their photo.',
      intro: 'Pick one clear, front-facing photo. You can change it before creating the preview.'
    },
    details: {
      step: 'Step 2 of 3',
      title: 'Make the character theirs.',
      intro: 'Confirm their name, eyes and hair, then create the free preview.'
    },
    rendering: {
      step: 'Creating preview',
      title: 'Building their story.',
      intro: 'We are preparing the cover and first story pages now.'
    },
    preview: {
      step: 'Step 3 of 3',
      title: 'Their preview is ready.',
      intro: 'Look through the preview. Checkout begins only if you choose to order.'
    }
  };

  const setState = (nextState) => {
    state = nextState;
    const selected = copyByState[nextState];
    uploadStep.hidden = nextState !== 'upload';
    detailsStep.hidden = nextState !== 'details';
    renderingStep.hidden = nextState !== 'rendering';
    previewStep.hidden = nextState !== 'preview';
    builderStep.textContent = selected.step;
    builderTitle.textContent = selected.title;
    builderIntro.textContent = selected.intro;
    dialog.classList.toggle('is-preview', nextState === 'preview');
    dialog.scrollTo({ top: 0, behavior: 'instant' });
  };

  const openDialog = () => {
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    if (sticky) sticky.hidden = true;
    setState(hasPreview ? 'preview' : (objectUrl ? 'details' : 'upload'));
  };

  const closeDialog = () => {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  const showPreviewPanel = (key) => {
    previewTabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.previewTab === key)));
    previewPanels.forEach((panel) => { panel.hidden = panel.dataset.previewPanel !== key; });
  };

  const populatePreview = () => {
    const childName = nameField.value.trim();
    form.querySelectorAll('[data-render-name], [data-preview-name], [data-cover-name], [data-story-name], [data-dedication-name], [data-choice-name]')
      .forEach((node) => { node.textContent = childName; });
    form.querySelector('[data-choice-eyes]').textContent = eyesField.value;
    form.querySelector('[data-choice-hair]').textContent = hairField.value;
  };

  const clearPhoto = () => {
    renderRun += 1;
    input.value = '';
    if (objectUrl) URL.revokeObjectURL(objectUrl);
    objectUrl = '';
    [photoPreview, renderingPhoto, coverPhoto, dedicationPhoto].forEach((image) => image.removeAttribute('src'));
    form.reset();
    previewViewed.value = 'No';
    hasPreview = false;
    fileError.hidden = true;
    fileError.textContent = '';
    showPreviewPanel('cover');
    setState('upload');
    input.focus();
  };

  const finishRendering = (token) => {
    if (token !== renderRun) return;
    renderStages.forEach((stage) => {
      stage.classList.remove('is-active');
      stage.classList.add('is-done');
    });
    window.setTimeout(() => {
      if (token !== renderRun) return;
      hasPreview = true;
      previewViewed.value = 'Yes';
      showPreviewPanel('cover');
      setState('preview');
      track('preview_view', { child_name_length: nameField.value.trim().length });
      previewStep.querySelector('[data-preview-tab]')?.focus({ preventScroll: true });
    }, 420);
  };

  const startRendering = () => {
    if (!form.reportValidity()) return;
    populatePreview();
    track('upload_complete', { file_type: input.files?.[0]?.type || '' });
    renderRun += 1;
    const token = renderRun;
    renderStages.forEach((stage) => stage.classList.remove('is-active', 'is-done'));
    setState('rendering');
    renderStages[0]?.classList.add('is-active');

    window.setTimeout(() => {
      if (token !== renderRun) return;
      renderStages[0]?.classList.remove('is-active');
      renderStages[0]?.classList.add('is-done');
      renderStages[1]?.classList.add('is-active');
    }, 650);
    window.setTimeout(() => {
      if (token !== renderRun) return;
      renderStages[1]?.classList.remove('is-active');
      renderStages[1]?.classList.add('is-done');
      renderStages[2]?.classList.add('is-active');
    }, 1350);
    window.setTimeout(() => finishRendering(token), 2100);
  };

  const orderBook = async () => {
    if (!hasPreview || previewViewed.value !== 'Yes') {
      orderError.textContent = 'Create and review the preview before ordering.';
      orderError.hidden = false;
      return;
    }

    orderError.hidden = true;
    orderButton.disabled = true;
    const originalLabel = orderButton.textContent;
    orderButton.textContent = 'Opening secure checkout…';

    try {
      const payload = new FormData(form);
      const selectedFile = input.files?.[0];
      payload.delete('properties[Child photo]');
      if (selectedFile) payload.append('properties[Child photo filename]', selectedFile.name);

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload
      });
      if (!response.ok) throw new Error('The book could not be added. Please try again.');

      track('add_to_cart', { preview_viewed: true });
      track('initiate_checkout', { preview_viewed: true });
      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    } catch (error) {
      orderError.textContent = error.message || 'Checkout could not start. Please try again.';
      orderError.hidden = false;
      orderButton.disabled = false;
      orderButton.textContent = originalLabel;
    }
  };

  openers.forEach((button) => button.addEventListener('click', openDialog));
  closeButton?.addEventListener('click', closeDialog);
  dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
  form.addEventListener('submit', (event) => event.preventDefault());

  input.addEventListener('change', () => {
    const file = input.files && input.files[0];
    if (!file) return;

    if (!allowedTypes.has(file.type)) {
      fileError.textContent = 'Choose a JPG or PNG image.';
      fileError.hidden = false;
      input.value = '';
      return;
    }
    if (file.size > maxBytes) {
      fileError.textContent = 'That image is over 10 MB. Choose a smaller file.';
      fileError.hidden = false;
      input.value = '';
      return;
    }

    fileError.hidden = true;
    fileError.textContent = '';
    if (objectUrl) URL.revokeObjectURL(objectUrl);
    objectUrl = URL.createObjectURL(file);
    [photoPreview, renderingPhoto, coverPhoto, dedicationPhoto].forEach((image) => { image.src = objectUrl; });
    fileName.textContent = file.name;
    hasPreview = false;
    previewViewed.value = 'No';
    setState('details');
    track('upload_start', { file_type: file.type, file_size_bucket: file.size < 3000000 ? 'under_3mb' : '3mb_to_10mb' });
    nameField.focus({ preventScroll: true });
  });

  reset.addEventListener('click', clearPhoto);
  generateButton.addEventListener('click', startRendering);
  orderButton.addEventListener('click', orderBook);
  editDetails.addEventListener('click', () => {
    hasPreview = false;
    previewViewed.value = 'No';
    setState('details');
    nameField.focus({ preventScroll: true });
  });
  previewTabs.forEach((tab) => tab.addEventListener('click', () => showPreviewPanel(tab.dataset.previewTab)));

  window.addEventListener('beforeunload', () => {
    if (objectUrl) URL.revokeObjectURL(objectUrl);
  }, { once: true });

  if (hero && sticky && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || Boolean(dialog.open);
    }, { threshold: 0.12 });
    observer.observe(hero);
    dialog.addEventListener('close', () => {
      sticky.hidden = hero.getBoundingClientRect().bottom > 0;
    });
  }
})();
